// extracted by mini-css-extract-plugin
module.exports = {"social-sharing":"social-sharing___F60aB","socialSharing":"social-sharing___F60aB","title":"title___1SBwl","network":"network___m81QS","link":"link___3g0Ck","icon":"icon___2_7GG"};